"use client";

import { c as _c } from "react/compiler-runtime";
import { NavigationMenuLink } from "@/components/ui/navigation-menu";
import { trackNavItemClicked } from "@/lib/analytics/segment";
import { getNavItemChildren, type NavItemEntry, navItemDestination } from "@/lib/contentful/navItem";
import { colorClass } from "@/lib/contentful/ui";
import { cn } from "@/lib/utils";
import { CmsLink } from "./CmsLink";
interface Props {
  columns: NavItemEntry[];
}
export function NavMegaMenu(t0) {
  const $ = _c(4);
  const {
    columns
  } = t0;
  let t1;
  if ($[0] !== columns) {
    t1 = columns.map(_temp2);
    $[0] = columns;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="flex gap-2 p-2">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp2(col) {
  const {
    title,
    color,
    isNewTab
  } = col.fields;
  const colChildren = getNavItemChildren(col);
  return <div key={col.sys.id} className="flex min-w-44 flex-col gap-0.5"><CmsLink destination={navItemDestination(col)} isNewTab={isNewTab} className={cn("rounded-sm px-2 py-1.5 text-sm font-semibold! no-underline! hover:bg-accent hover:opacity-100!", colorClass(color))} onNavigate={href => trackNavItemClicked({
      label: title,
      destinationUrl: href,
      level: 2
    })}>{title}</CmsLink>{colChildren.map(_temp)}</div>;
}
function _temp(colItem) {
  const {
    title: itemTitle,
    color: itemColor,
    isNewTab: itemIsNewTab
  } = colItem.fields;
  return <NavigationMenuLink key={colItem.sys.id} asChild={true}><CmsLink destination={navItemDestination(colItem)} isNewTab={itemIsNewTab} className={cn("rounded-sm px-2 py-1 text-sm no-underline! hover:opacity-100!", colorClass(itemColor))} onNavigate={href_0 => trackNavItemClicked({
      label: itemTitle,
      destinationUrl: href_0,
      level: 3
    })}>{itemTitle}</CmsLink></NavigationMenuLink>;
}